var modules_1be33e45 = {"container":"_x2nvki","firstColumn":"_1euh70a","secondColumn":"_13pw9on"};
import "../../../assets/CFJxvR4Y.css";

export { modules_1be33e45 as default };
//# sourceMappingURL=StoresBanner.module.less.js.map
